import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  sRoot: {
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    background: theme.palette.background.defaultGradient
  }
}));
